$(function() {

  document.addEventListener('DOMContentLoaded', function() {
    var closeButton = document.getElementById('btn-close-wrapper');

    function closePopup() {
        var popup = document.querySelector('.popup-form');
        if (popup) {
            popup.style.display = 'none';
        }
    }

    if (closeButton) {
        closeButton.addEventListener('click', closePopup);
        closeButton.addEventListener('touchstart', closePopup);
    }
  });


  if (window.location.href.indexOf('/collections/all') > -1 || window.location.href.indexOf('/products/') > -1) {
    // window.location.href = '/';
  }

  if (window.location.href.indexOf('/collections/') > -1) {
    $('.baseline-filters ul li').each(function() {
      var url_string = window.location.href.split("=");
      if ($(this).find('a').text() == url_string[1]) {
        $('.baseline-filters ul li a').removeClass('active');
        $(this).find('a').addClass('active');
      }
    });
    
  }
  
});